import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackProfilePageView = (userId?: string): void => {
  trackingService.trackEvent(
    'PROFILE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '/inicio/meus-dados',
      placement: '',
      surface: '',
      flow: 'cadastro usuário',
      step: 'dados pessoais',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileTabPersonalDataClick = (userId?: string): void => {
  trackingService.trackEvent(
    'USER_INFO',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '/inicio/meus-dados',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro usuário',
      step: 'continuar cadastro',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileTabProfessionalDataClick = (userId?: string): void => {
  trackingService.trackEvent(
    'USER_INFO',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '/inicio/meus-dados',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro usuário',
      step: 'dados profissionais',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileTabServiceLocationClick = (userId?: string): void => {
  trackingService.trackEvent(
    'USER_INFO',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro usuário',
      step: 'local de atendimento',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileTabSecurityClick = (userId?: string): void => {
  trackingService.trackEvent(
    'USER_INFO',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'menu',
      surface: 'list',
      flow: 'cadastro usuário',
      step: 'segurança',
      element: 'tab',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileDeleteAccountClick = (userId?: string): void => {
  trackingService.trackEvent(
    'REMOVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'list',
      flow: 'excluir conta',
      step: 'iniciar exclusão',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileLogoutClick = (userId?: string): void => {
  trackingService.trackEvent(
    'LOGOUT',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'header',
      surface: 'popover',
      flow: 'logout',
      step: 'sair',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfilePersonalDataSaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'atualizar dados pessoais',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileProfessionalDataSaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'atualizar dados profissionais',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileDeleteAccountConfirmClick = (userId?: string): void => {
  trackingService.trackEvent(
    'REMOVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'list',
      flow: 'excluir conta',
      step: 'confirmar exclusão',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileServiceLocationWhatsMyCepClick = (userId?: string): void => {
  trackingService.trackEvent(
    'WHATS_MY_CEP',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'atualizar local atendimento',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileServiceLocationSaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'atualizar local atendimento',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileSecurityForgotPasswordClick = (userId?: string): void => {
  trackingService.trackEvent(
    'FORGOT_PASSWORD',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'esqueceu senha',
      step: 'inicio',
      element: 'link',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackProfileSecuritySaveClick = (userId?: string): void => {
  trackingService.trackEvent(
    'SAVE',
    PRODUCT_NAME,
    {
      page: 'perfil',
      route: '',
      placement: 'main',
      surface: 'form',
      flow: 'cadastro usuário',
      step: 'trocar senha',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
